import React from "react";

export function AnalyticsIncidentCardSkeleton() {
  return (
    <div
      className="analytics-incident-card-skeleton-wrap"
      aria-busy="true"
      aria-label="Загрузка деталей инцидента"
    >
      {Array.from({ length: 2 }).map((_, block) => (
        <div key={block} className="analytics-incident-card-skeleton">
          <div className="analytics-skeleton-title analytics-skeleton-bar" />
          {Array.from({ length: 3 }).map((__, row) => (
            <div
              key={row}
              className="analytics-skeleton-bar analytics-skeleton-bar--horizontal"
              style={{ width: row === 0 ? "90%" : row === 1 ? "70%" : "55%" }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
